import React from 'react'
import { Link } from 'gatsby'
import Img from 'gatsby-image'
import styles from './notes-preview.module.scss'

function NotesPreview({ img, title, excerpt, slug }) {
  return (
    <div className={styles.notes__preview}>
      {img ? <Img className={styles.notes__preview__img} fluid={img} /> : null}
      <div>
        <Link to={slug}>
          <h3>{title}</h3>
        </Link>
        <p dangerouslySetInnerHTML={{ __html: excerpt }} />
        <Link className="link__blue" to={slug}>
          Baca →
        </Link>
      </div>
    </div>
  )
}

export default NotesPreview
